/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drastic_Tech_Processing_LabelInputs */

const en_drastic_tech_processing_label = /** @type {(inputs: Drastic_Tech_Processing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processing... please wait.`)
};

const fr_drastic_tech_processing_label = /** @type {(inputs: Drastic_Tech_Processing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traitement... veuillez patienter.`)
};

const de_drastic_tech_processing_label = /** @type {(inputs: Drastic_Tech_Processing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verarbeitung läuft... Bitte warten.`)
};

const it_drastic_tech_processing_label = /** @type {(inputs: Drastic_Tech_Processing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elaborazione in corso... attendere prego.`)
};

const ru_drastic_tech_processing_label = /** @type {(inputs: Drastic_Tech_Processing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обработка... пожалуйста, подождите.`)
};

const es_drastic_tech_processing_label = /** @type {(inputs: Drastic_Tech_Processing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Procesando... por favor espere.`)
};

const zh_cn2_drastic_tech_processing_label = /** @type {(inputs: Drastic_Tech_Processing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在处理……请稍候。`)
};

const ja_drastic_tech_processing_label = /** @type {(inputs: Drastic_Tech_Processing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`処理中です...お待ちください。`)
};

const hi_drastic_tech_processing_label = /** @type {(inputs: Drastic_Tech_Processing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रक्रिया जारी है... कृपया प्रतीक्षा करें।`)
};

const pt_pt2_drastic_tech_processing_label = /** @type {(inputs: Drastic_Tech_Processing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processando... aguarde.`)
};

/**
* | output |
* | --- |
* | "Processing... please wait." |
*
* @param {Drastic_Tech_Processing_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_processing_label = /** @type {((inputs?: Drastic_Tech_Processing_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Processing_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_drastic_tech_processing_label(inputs)
	if (locale === "de") return de_drastic_tech_processing_label(inputs)
	if (locale === "it") return it_drastic_tech_processing_label(inputs)
	if (locale === "ru") return ru_drastic_tech_processing_label(inputs)
	if (locale === "es") return es_drastic_tech_processing_label(inputs)
	if (locale === "zh-CN") return zh_cn2_drastic_tech_processing_label(inputs)
	if (locale === "ja") return ja_drastic_tech_processing_label(inputs)
	if (locale === "hi") return hi_drastic_tech_processing_label(inputs)
	if (locale === "pt-PT") return pt_pt2_drastic_tech_processing_label(inputs)
	return en_drastic_tech_processing_label(inputs)
});